export const normalizeJson = (obj: unknown): unknown => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(normalizeJson);

  const sortedKeys = Object.keys(obj as Record<string, unknown>).sort();
  const normalized: Record<string, unknown> = {};
  for (const key of sortedKeys) {
    normalized[key] = normalizeJson((obj as Record<string, unknown>)[key]);
  }
  return normalized;
};

// Returns a canonical pretty-printed JSON string with sorted keys, or null on parse failure.
export const canonicalizeJsonString = (raw: string): string | null => {
  if (!raw) return '';
  try {
    return JSON.stringify(normalizeJson(JSON.parse(raw)), null, 2);
  } catch {
    return null;
  }
};
